import { observer } from 'mobx-react-lite'
import { ApproveDraftInReviewDialog } from '@/features/jobs/details/components/ApproveDraftInReviewDialog'
import { type ApproveDraftInReviewDialogViewModel } from './ApproveDraftInReviewDialogViewModel'

export interface ApproveDraftInReviewDialogContainerProps {
  vm: ApproveDraftInReviewDialogViewModel
}

export const ApproveDraftInReviewDialogContainer = observer(
  function ApproveDraftInReviewDialogContainer({
    vm,
  }: ApproveDraftInReviewDialogContainerProps) {
    return (
      <ApproveDraftInReviewDialog
        showing={vm.modal.showing}
        isApprovePending={vm.approveDraft.pending}
        onClose={vm.modal.close}
        onApprove={vm.approveDraft}
      />
    )
  },
)
